import { Activity, Sparkles } from "lucide-react";

const SERVICES = [
  {
    icon: Activity,
    title: "RAPID NeuroFascial Reset",
    desc: "Advanced, science-based, active-movement therapy that targets the nervous system to resolve pain at its source. Fully clothed sessions.",
    badge: "Signature",
  },
  {
    icon: Sparkles,
    title: "Integrated Care Plans",
    desc: "Custom protocols combining the right techniques for your unique condition and recovery timeline.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-20 sm:py-28 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-blue-800 mb-4">
            Expert Treatments
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 leading-[1.1]">
            Clinical therapies, tailored to your recovery.
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            Every body tells a different story. I only use powerful, proven techniques I believe in —
            then craft a session that fits the person, not just the pain.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl">
          {SERVICES.map((s, i) => (
            <div
              key={s.title}
              data-testid={`service-card-${i}`}
              className="group relative bg-white p-7 rounded-3xl border border-slate-100 shadow-sm hover:shadow-xl hover:shadow-blue-900/5 hover:-translate-y-1 hover:border-blue-100 transition-all duration-300"
            >
              {s.badge && (
                <div className="absolute top-5 right-5 text-[10px] uppercase tracking-[0.16em] font-bold px-2.5 py-1 rounded-full bg-blue-800 text-white">
                  {s.badge}
                </div>
              )}
              <div className="w-12 h-12 rounded-2xl bg-blue-50 group-hover:bg-blue-100 transition-colors flex items-center justify-center mb-5">
                <s.icon size={22} strokeWidth={1.6} className="text-blue-800" />
              </div>
              <h3 className="font-display font-bold text-xl text-slate-900 mb-2 tracking-tight">
                {s.title}
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
